<template>
  <div></div>
</template>
<script>
import axios from 'axios'
import helpers from "@/helpers"
import { baseApiUrl } from '@/global'
import pdfmake from "pdfmake"
import pdffonts from "pdfmake/build/vfs_fonts.js"
import { CPF, CNPJ } from 'cpf_cnpj'

export default {
  data() {
    return {
      orderData: {},
      companyData: {},
      products: [],
      parcelas: [],
      taxes: null,
      logoB64: '',
      quantidadeTotalOfOrder: 0,
      valorTotalOfOrder: 0
    }
  },
  methods: {
    async generate(idOrder, company, calculateST) {
      this.helpers = helpers
      this.taxes = null
      if (!pdfmake.vfs) {
        pdfmake.vfs = pdffonts.pdfMake.vfs;
      }
      await this.getOrder(idOrder, company)
      await this.fixVarsToTable()
      if (calculateST) this.calculateST()
      await this.makePDF()
    },
    async getOrder(idOrder, company) {
      const { data } = await axios.get(`${baseApiUrl}/bling/order/${idOrder}`, {
        params: {
          company
        }
      })
      this.orderData = data.order
      this.companyData = data.company
      console.log(this.orderData);
    },
    calculateST() {
      if (!this.orderData.impostos) return

      const { impostos } = this.orderData
      const baseICMSInter = this.orderData.totalvenda
      const valorICMSInter = baseICMSInter * (impostos.icmsInter / 100)
      const baseICMSST = baseICMSInter * (1 + (impostos.mva / 100))
      const valorICMSST = baseICMSST * (impostos.icmsST / 100) - valorICMSInter
      this.taxes = {
        baseICMSST: baseICMSST.toFixed(2),
        valorICMSST: valorICMSST.toFixed(2),
      }
    },
    async fixVarsToTable() {
      this.products = []
      this.quantidadeTotalOfOrder = 0
      this.valorTotalOfOrder = 0

      const logoB64 = await axios.get(this.companyData.logo, {
        responseType: 'arraybuffer',
        headers: { Authorization: '' }
      })
      this.logoB64 = 'data:image/jpeg;base64,' + Buffer.from(logoB64.data, 'binary').toString('base64')
      for (const { item } of this.orderData.itens) {
        this.products.push([
          item.codigo,
          item.descricao,
          +item.quantidade,
          (+item.valorunidade).toFixed(2).replace('.', ','),
          (item.quantidade * item.valorunidade).toFixed(2).replace('.', ',')
        ])
        this.quantidadeTotalOfOrder += +item.quantidade
        this.valorTotalOfOrder += item.quantidade * item.valorunidade
      }
      this.products.push([
        { text: '', border: [false, false, false, false] },
        { text: '', border: [false, false, false, false] },
        {
          text: this.quantidadeTotalOfOrder,
          bold: true,
        },
        { text: '', border: [false, false, false, false] },
        {
          text: this.valorTotalOfOrder.toFixed(2).replace('.', ','),
          bold: true,
        },
      ])
    },
    generateFaturaAndCondicaoPagamento() {
      let parcelas = this.orderData.parcelas
      if (!parcelas) return { condicaoPagamento: '-', fatura: null }

      let valueToAddToEachParcela = 0
      if (this.taxes) valueToAddToEachParcela = +this.taxes.valorICMSST / parcelas.length

      const condicaoPagamento = parcelas.reduce((acc, item) => {
        item = item.parcela
        const dateDiff = this.helpers.dateHelper.getDiffBetweenTwoDates(item.dataVencimento, this.orderData.data, 'days')
        return acc + ' ' + dateDiff
      }, '')

      const faturasImpar = parcelas.reduce((acc, item, i) => {
        item = item.parcela
        if ((i + 1) % 2 === 0) return acc
        const fatura = `${i + 1} ${this.helpers.dateHelper.formatDateToPTBR(item.dataVencimento)} ${this.helpers.moneyHelper.formatNumberToCurrency(+item.valor + valueToAddToEachParcela)}`
        return acc == '' ? fatura : acc + '\t\t' + fatura
      }, '')

      const faturasPar = parcelas.reduce((acc, item, i) => {
        item = item.parcela
        if ((i + 1) % 2 !== 0) return acc
        const fatura = `${i + 1} ${this.helpers.dateHelper.formatDateToPTBR(item.dataVencimento)} ${this.helpers.moneyHelper.formatNumberToCurrency(+item.valor + valueToAddToEachParcela)}`
        return acc == '' ? fatura : acc + '\t\t' + fatura
      }, '')

      return { condicaoPagamento: condicaoPagamento.trim(), fatura: faturasImpar + '\n' + faturasPar }
    },
    makePDF() {
      const cpfCnpj = CPF.isValid(this.orderData.cliente.cnpj) ? CPF.format(this.orderData.cliente.cnpj) : CNPJ.format(this.orderData.cliente.cnpj)
      const tipoFrete = this.orderData.transporte && this.orderData.transporte.tipo_frete == 'R' ? 'CIF' : 'FOB'
      const { condicaoPagamento, fatura } = this.generateFaturaAndCondicaoPagamento()

      let docDefinition = {
        info: {
          title: `PEDIDO N° ${this.orderData.numero}`,
        },
        header: {
          style: 'header',
          columns: [{
              image: this.logoB64,
              fit: [60, 60],
              width: 70,
              link: 'https://www.regnaparts.com/',
            },
            {
              width: 400,
              stack: [
                { text: this.companyData.razaoSocial },
                { text: `${this.companyData.endereco} - ${this.companyData.bairro}` },
                { text: `${this.companyData.cidade}/${this.companyData.estado} - ${this.companyData.cep}` },
                { text: `financeiro@regnaparts.com.br - ${this.companyData.telefone}` },
                { text: this.companyData.cnpj }
              ],
            },
            {
              margin: [30, 15, 0, 0],
              width: 'auto',
              text: `N° ${this.orderData.numero}`,
              fontSize: 15
            }
          ],
          margin: [15, 10, 10, 0]
        },
        content: [
          { text: 'DESTINÁTARIO / REMETENTE', style: 'contentHeader' },
          {
            table: {
              widths: ['12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%'],
              body: [
                [
                  { stack: [{ text: 'RAZÃO SOCIAL', bold: true }, this.orderData.cliente.nome], colSpan: 5 },
                  [''],
                  [''],
                  [''],
                  [''],
                  { stack: [{ text: 'CPF/CNPJ', bold: true }, cpfCnpj], colSpan: 2 },
                  [''],
                  [{ text: 'I.E.', bold: true }, this.orderData.cliente.ie || 'ISENTO'],
                ],
                [
                  { stack: [{ text: 'ENDEREÇO', bold: true }, `${this.orderData.cliente.endereco.toUpperCase()}, ${this.orderData.cliente.numero} - ${this.orderData.cliente.bairro.toUpperCase()} - ${this.orderData.cliente.cidade.toUpperCase()}/${this.orderData.cliente.uf.toUpperCase()} - ${this.orderData.cliente.cep} `], colSpan: 7 },
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [{ text: 'DATA EMISSÃO', bold: true }, this.helpers.dateHelper.formatDateToPTBR(this.orderData.data)],
                ],
                // [
                //   { stack: [{ text: 'EMAIL', bold: true }, this.orderData.cliente.email], colSpan: 6 },
                //   [''],
                //   [''],
                //   [''],
                //   [''],
                //   [''],
                //   { stack: [{ text: 'FONE / CELULAR', bold: true }, this.orderData.cliente.fone || this.orderData.cliente.celular], colSpan: 2 },
                //   [''],
                //   // [{ text: 'VALIDADE', bold: true }, this.helpers.dateHelper.addDaysToDate(this.dateNow, 5)],
                // ],
              ],
            },
          },
          { text: 'INFORMAÇÕES COMERCIAIS', style: 'contentHeader' },
          {
            table: {
              widths: ['50%', '50%'],
              body: [
                [
                  { stack: [{ text: 'REPRESENTANTE', bold: true }, this.orderData.vendedor] },
                  { stack: [{ text: 'CONDIÇÃO DE PAGAMENTO', bold: true }, condicaoPagamento] },
                ],
              ]
            }
          },
          fatura && { text: 'FATURA', style: 'contentHeader' },
          fatura && {
            table: {
              widths: ['100%'],
              body: [
                [fatura]
              ]
            }
          },
          this.taxes && { text: 'CÁLCULO DO IMPOSTO', style: 'contentHeader' },
          this.taxes && {
            table: {
              widths: ['21%', '14%', '25%', '17%', '23%'],
              body: [
                [
                  { stack: [{ text: 'BASE DE CÁLCULO DO ICMS', bold: true }, "0,00"] },
                  { stack: [{ text: 'VALOR DO ICMS', bold: true }, "0,00"] },
                  { stack: [{ text: 'BASE DE CÁLCULO DO ICMS SUBST.', bold: true }, this.taxes.baseICMSST.replace('.', ',')] },
                  { stack: [{ text: 'VALOR DO ICMS SUBST.', bold: true }, this.taxes.valorICMSST.replace('.', ',')] },
                  { stack: [{ text: 'VALOR TOTAL DOS PRODUTOS', bold: true }, this.orderData.totalprodutos.replace('.', ',')] },
                ],
                [
                  { stack: [{ text: 'VALOR DO FRETE', bold: true }, this.orderData.valorfrete.replace('.', ',')] },
                  { stack: [{ text: 'DESCONTO', bold: true }, this.orderData.desconto] },
                  { stack: [{ text: 'OUTRAS DESPESAS ACESSÓRIAS', bold: true }, "0,00"] },
                  { stack: [{ text: 'VALOR DO IPI', bold: true }, "0,00"] },
                  { stack: [{ text: 'VALOR TOTAL DA NOTA', bold: true }, (+this.orderData.totalvenda + +this.taxes.valorICMSST).toFixed(2).replace('.', ',')] },
                ]
              ]
            }
          },
          { text: 'PRODUTOS', style: 'contentHeader' },
          {
            table: {
              widths: ['auto', '*', 'auto', 'auto', 'auto'],
              body: [
                [
                  { text: 'CÓDIGO', bold: true },
                  { text: 'DESCRIÇÃO', bold: true },
                  { text: 'QTD', bold: true },
                  { text: 'VLR UNIT', bold: true },
                  { text: 'VLR TOTAL', bold: true }
                ],
                ...this.products,
              ]
            },
          },
          this.orderData.transporte && { text: 'TRANSPORTADORA', style: 'contentHeader' },
          this.orderData.transporte && {
            table: {
              widths: ['12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%', '12.5%'],
              body: [
                [
                  { stack: [{ text: 'NOME / RAZÃO SOCIAL', bold: true }, this.orderData.transporte.transportadora], colSpan: 5 },
                  [''],
                  [''],
                  [''],
                  [''],
                  { stack: [{ text: 'CPF/CNPJ', bold: true }, CNPJ.format(this.orderData.transporte.cnpj)], colSpan: 2 }, // mudar pra cnpj transportadora
                  [''],
                  [{ text: 'TIPO DE FRETE', bold: true }, tipoFrete],
                ],
                // [
                //   { stack: [{ text: 'ENDEREÇO', bold: true }, this.orderData.transportadoras.endereco + (this.orderData.transportadoras.numeroCasa ? ', ' + this.orderData.transportadoras.numeroCasa : '')], colSpan: 3 },
                //   [''],
                //   [''],
                //   { stack: [{ text: 'MUNICÍPIO', bold: true }, this.orderData.transportadoras.cidade] },
                //   { stack: [{ text: 'BAIRRO / DISTRITO', bold: true }, this.orderData.transportadoras.bairro], colSpan: 2 },
                //   [''],
                //   [{ text: 'UF', bold: true }, this.orderData.transportadoras.estado],
                //   [{ text: 'CEP', bold: true }, this.orderData.transportadoras.cep],
                // ],
                [
                  { stack: [{ text: 'VOLUMES', bold: true }, this.orderData.transporte.qtde_volumes], colSpan: tipoFrete == 'FOB' ? 8 : 4 },
                  [''],
                  [''],
                  [''],
                  tipoFrete == 'FOB' ? [''] : { stack: [{ text: 'VALOR DO FRETE', bold: true }, this.orderData.valorfrete.replace('.', ',')], colSpan: 4 },
                  [''],
                  [''],
                  [''],
                ],
              ],
            },
          },
          { text: 'INFORMAÇÕES ADICIONAIS', style: 'contentHeader' },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  [{ text: 'OBSERVAÇÕES', bold: true }, this.orderData.observacoes.toUpperCase()]
                ]
              ]
            }
          }
        ],
        styles: {
          contentHeader: {
            fontSize: 8,
            margin: [0, 15, 0, 0],
            bold: true,
            color: '#595959',
          },
          header: {
            fontSize: 9,
          }
        },
        defaultStyle: {
          fontSize: 8,
        },
        pageMargins: [10, 65, 10, 55]
      }
      pdfmake.createPdf(docDefinition).open()
    }
  },
}

</script>
